import api from "src/api/axiosInstance";
import { showToast } from "src/components/ToastProvider";
import ToastTypes from "src/enum/ToastTypes";
import { deleteAllFromCart } from "src/store/slices/cart-slice";
import { asyncDeleteCartItem } from "src/store/slices/cartThunks";
import { store } from "src/store/store";

/**
 * Fetches user orders with pagination
 * @param {number} page - Current page number
 * @param {number} limit - Number of orders per page
 * @returns {Promise<Array>} - Array of order objects or empty array
 */
export const fetchOrders = async (page = 1, limit = 10) => {
  try {
    const response = await api.get(`/orders?page=${page}&limit=${limit}`);
    if (response.data.status === 0) {
      return response.data.data || [];
    }
     else {
      showToast(
        response.data.message || "Failed to fetch orders",
        ToastTypes.ERROR
      );
      return [];
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || "An error occurred while fetching orders";
    showToast(errorMessage, ToastTypes.ERROR);
    return [];
  }
};

/**
 * Fetches order details by UUID
 * @param {string} uuid - The UUID of the order
 * @returns {Promise<Object>} - Order details object or null
 */
export const fetchOrderDetail = async (uuid) => {
  try {
    const response = await api.get(`/order-uuid/${uuid}`);
    if (response.data) {
      return response.data;
    } else {
      showToast("Failed to fetch order details", ToastTypes.ERROR);
      return null;
    }
  } catch (error) {
    const errorMessage = error.response?.data?.message || "An error occurred while fetching order details";
    showToast(errorMessage, ToastTypes.ERROR);
    return null;
  }
};

export const createOrder = async () => {
  try {
    await api.post(`/orders`);
  } catch (error) {
    console.log(error);
  }
};

export const placeOrderApi = async (orderId) => {
  try {
    const response = await api.post(`checkout/${orderId}`);
    if (response.data && response.data.status === 1) {
      showToast(response.data.message || "Something went wrong with your order", ToastTypes.ERROR);
      return null; 
    }

    const cartItems = store.getState().cart.cartItems;
    const accessToken = store.getState().accessToken.token;

// Clear each cart item from server
if (cartItems.length > 0 && accessToken) {
  const deletePromises = cartItems.map(item => 
    store.dispatch(asyncDeleteCartItem(item, item.cartItemId, accessToken))
  );
  
  // Wait for all delete operations to complete
  await Promise.all(deletePromises);
}
    // Success case - clear cart and return data
    store.dispatch(deleteAllFromCart());
    return response.data;
  } catch (error) {
    console.log(error);
    showToast("Unable to process your order. Please try again later.", ToastTypes.ERROR);
    return null;
  }
};

export const updateCustomerInfoOrderApi = async (order, customerName, customerEmail) => {
  const body = JSON.stringify({
    ID: order.ID,
    customerId: order.customerId,
    customerName: customerName,
    customerEmail: customerEmail,
  });
  await api.put(`/orders`, body);
};
